import { render } from "./Scroll-To-Top.vue?vue&type=template&id=551867bd&scoped=true"
import script from "./Scroll-To-Top.vue?vue&type=script&lang=js"
export * from "./Scroll-To-Top.vue?vue&type=script&lang=js"

import "./Scroll-To-Top.vue?vue&type=style&index=0&id=551867bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551867bd"]])

export default __exports__